import React from 'react';
import { industries } from '../data/site';
import { Reveal } from './Reveal';
export function Industries() {
  return <section aria-labelledby="industries-heading" className="bg-white py-20 lg:py-28" data-id="element-204" data-mp="3r7anhet295b">
      <div className="mx-auto max-w-container px-5 lg:px-8" data-id="element-205" data-mp="io6fixi9vnw3">
        <Reveal className="max-w-2xl" data-id="element-206" data-mp="dolkgy683zon">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-cobalt-700" data-id="element-207" data-mp="dnio4aq4t51c">
            Properties We Serve
          </p>
          <h2 id="industries-heading" className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-charcoal-900 sm:text-[2.75rem]" data-id="element-208" data-mp="rlqmmn2tgeem">
            Built for Commercial Properties
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-209" data-mp="wg4ieqle4njt">
          {industries.map((industry, index) => <Reveal as="li" key={industry.title} delay={index % 3 * 0.06} data-id="element-210" data-mp="1aci0o1xr0szc" data-mpi={index}>
              <div className="group relative isolate h-64 overflow-hidden rounded-lg lg:h-72" data-id="element-211" data-mp="16ekbgz3za6vy">
                <img src={industry.image} alt={industry.alt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" loading="lazy" data-id="element-212" data-mp="1yrx49s195vvs" />
                <div className="absolute inset-0 bg-charcoal-900/45" aria-hidden="true" data-id="element-213" data-mp="2creri2ywh131" />
                <div className="absolute inset-x-0 bottom-0 h-1/2 bg-charcoal-900/60" aria-hidden="true" data-id="element-214" data-mp="2hnna5qcb3cey" />
                <h3 className="absolute inset-x-0 bottom-0 p-6 text-lg font-bold leading-snug tracking-tight text-white" data-id="element-215" data-mp="2qj2yxsy7f1do">
                  {industry.title}
                </h3>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}